import React from "react";
import accounting from "accounting";
import { CURRENCY } from "../../helpers/variables";

const statisticsHeader =  [
    {key: 'advancedDisbursements', value: 'Advance Disbursements'},
    {key: 'applied', value: 'Applied'},
    {key: 'rejected', value: 'Rejected'},
    {key: 'approved', value: 'Approved'},
    {key: 'processing', value: 'Processing'},
    {key: 'paid', value: 'Paid'},
    {key: 'part-settled', value: 'Part Settled'},
    {key: 'Settled', value: 'Settled'},
    {key: 'total', value: 'Total'},
];

const AdvanceDisbursementsOverviewTable = (props) => {
    const {
        totalValueOfAdvancedDisbursements,
        totalValueOfApplied,
        totalValueOfApproved,
        totalSettledValue,
        totalRejectedValue,
        totalProcessingValue,
        totalPaidValue,
        totalPartSettledValue,
        totalNumberOfAdvancedDisbursements,
        totalNumberOfApplied,
        totalNumberOfApproved,
        totalSettledRecords,
        totalRejectedRecords,
        totalProcessingRecords,
        totalPaidRecords,
        totalPartSettledRecords,
        isAragUser
    } = props;
    return (
        <div className={"table-responsive"}>
            <table className="table table-striped agents-list-table">
                <thead className="agents-list-table-head">
                <tr className="agents-list-table-column">
                    {statisticsHeader.map(header => {
                        return <th  key={header.key}>{header.value}</th>
                    })}
                </tr>
                </thead>
                <tbody className="appFormRefSettings-tbody">
                {isAragUser && <tr> 
                    <td className="premiumSettingsWizard-table-group-of-rows premiumSettingsWizard-table-data premiumSettingsWizard-table-data-border-top premiumSettingsWizard-vertical-label-wrapper">
                           <span className="">
                               {"Number of Advance"}<br></br>{"Disbursements per status"}
                           </span>
                    </td>
                    <td>{totalNumberOfApplied}</td>
                    <td>{totalRejectedRecords}</td>
                    <td>{totalNumberOfApproved}</td>
                    <td>{totalProcessingRecords}</td>
                    <td>{totalPaidRecords}</td>
                    <td>{totalPartSettledRecords}</td>
                    <td>{totalSettledRecords}</td>
                    <td>{totalNumberOfAdvancedDisbursements}</td>
                </tr>}
                <tr>
                    <td className="premiumSettingsWizard-table-group-of-rows premiumSettingsWizard-table-data premiumSettingsWizard-table-data-border-top premiumSettingsWizard-vertical-label-wrapper">
                            <span className="">
                                {"Total amount of Advance"}<br></br>{"Disbursements per status"}
                            </span>
                    </td>
                    <td>{accounting.formatMoney(totalValueOfApplied, CURRENCY, 2)}</td>
                    <td>{accounting.formatMoney(totalRejectedValue, CURRENCY, 2)}</td>
                    <td>{accounting.formatMoney(totalValueOfApproved, CURRENCY, 2)}</td>
                    <td>{accounting.formatMoney(totalProcessingValue, CURRENCY, 2)}</td>
                    <td>{accounting.formatMoney(totalPaidValue, CURRENCY, 2)}</td>
                    <td>{accounting.formatMoney(totalPartSettledValue, CURRENCY, 2)}</td>
                    <td>{accounting.formatMoney(totalSettledValue, CURRENCY, 2)}</td>
                    <td>{accounting.formatMoney(totalValueOfAdvancedDisbursements, CURRENCY, 2)}</td>
                </tr>
                </tbody>
            </table>
        </div>
    )
};

export default AdvanceDisbursementsOverviewTable;